// extracted by mini-css-extract-plugin
export default {"wrapper":"BlankLayout_wrapper__a4cz+","enWrapper":"BlankLayout_enWrapper__0NzZd","ruWrapper":"BlankLayout_ruWrapper__C36w8"};